import { contentAPI } from '../config';
import { getCookie } from './dom';

const getDataOptions = (body, headers = {}) => {
	const fetchOptions = {
		method: 'GET',
		mode: 'cors',
		cache: 'no-cache',
		headers,
	};

	const previewCode = typeof window !== 'undefined' ? getCookie('previewCode') : false;
	if (previewCode) body.previewCode = previewCode;

	if (!body.previewCode) delete body.previewCode;

	if (typeof process !== 'undefined' && process.env.API) {
		fetchOptions.headers['api-authorization'] = process.env.API;
		if (body.ip) fetchOptions.headers['x-forwarded-for'] = body.ip;
		delete body.ip;
	}

	if (body !== null && typeof body === 'object' && Object.keys(body).length > 0) {
		fetchOptions.method = 'POST';
		fetchOptions.accept = 'application/json, text/plain, */*;';
		fetchOptions.body = JSON.stringify(body);
	}

	return fetchOptions;
};

const fetchData = (path, body = {}) => {
	const encodedPath = path.split('/').map((part) => encodeURIComponent(part)).join('/');
	// debug: return fetch(`${contentAPI}${encodedPath}`, getDataOptions(body)).then((resp) => console.log('DEBUG: resp', resp.json()).catch((err) => console.log('DEBUG: was not able to be fetched', err));
	return fetch(`${contentAPI}${encodedPath}`, getDataOptions(body)).then((data) => data.json()).catch((err) => console.log('DEBUG: was not able to be fetched', err));
};

const fetchCheckout = (body = {}) => fetch('/checkout', getDataOptions(body, { 'Content-Type': 'application/json' })).then((data) => data.json()).catch((err) => console.log('DEBUG: was not able to be fetched', err));

export { fetchData, fetchCheckout };
